<template>
  <div class="detail-affiliate-user">
    <div class="margin-top">
      <el-table
        :data="affiliateUsers"
        border
        style="width: 100%"
        v-loading="loading">
        <el-table-column
          prop="userName"
          :label="$t('affiliate.distributorName')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="level"
          :label="$t('affiliate.distributorLevel')"
          align="center">
          <template slot-scope="scope">
            {{ _level(scope.row.level) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="totalCommission"
          :label="$t('affiliate.totalCommission')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="availableCommission"
          :label="$t('affiliate.availableCommission')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="withdrawnCommission"
          :label="$t('affiliate.withdrawnCommission')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('affiliate.createTime')"
          align="center">
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { listAffiliateUser } from '@/api/affiliate/affiliateUserApi'

export default {
  name: 'DetailAffiliateUser',
  data() {
    return {
      loading: false,
      affiliateUsers: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      parentId: ''
    }
  },
  methods: {
    loadData(params) {
      this.parentId = params.auId
      this.getList()
    },
    async getList() {
      this.loading = true
      try {
        const res = await listAffiliateUser({
          parentId: this.parentId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        })
        this.affiliateUsers = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取二级分销员列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    _level(state) {
      if (state === "1") {
        return this.$t('affiliate.firstLevel')
      }
      if (state === "2") {
        return this.$t('affiliate.secondLevel')
      }
      return ''
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>